// src/Dashboard/pages/teacher/AttendanceTable/utils/attendanceTableUtils.js

export function isActiveGroup(group) {
  return (
    group?.is_active === true ||
    group?.is_active === 1 ||
    group?.is_active === "1" ||
    group?.is_active === "true"
  );
}

export function daysArray(yyyyMM) {
  if (!yyyyMM) return [];

  const [year, month] = String(yyyyMM).split("-").map(Number);

  if (!year || !month) return [];

  const count = new Date(year, month, 0).getDate();

  return Array.from({ length: count }, (_, index) =>
    String(index + 1).padStart(2, "0")
  );
}

export function generateSeasonMonths(season) {
  const [startYear, endYear] = String(season || "")
    .split("-")
    .map(Number);

  if (!startYear || !endYear) return [];

  const list = [];

  for (let month = 6; month <= 11; month += 1) {
    const value = `${startYear}-${String(month + 1).padStart(2, "0")}`;
    const label = new Date(startYear, month).toLocaleString("fr-FR", {
      month: "long",
      year: "numeric",
    });

    list.push({ value, label });
  }

  for (let month = 0; month <= 7; month += 1) {
    const value = `${endYear}-${String(month + 1).padStart(2, "0")}`;
    const label = new Date(endYear, month).toLocaleString("fr-FR", {
      month: "long",
      year: "numeric",
    });

    list.push({ value, label });
  }

  return list;
}

export function getCurrentSeasonMonth(months = []) {
  const now = new Date();
  const current = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
    2,
    "0"
  )}`;

  return months.some((month) => month.value === current) ? current : "";
}

export function formatMonthLabel(yyyyMM) {
  if (!yyyyMM) return "—";

  const [year, month] = String(yyyyMM).split("-").map(Number);

  if (!year || !month) return yyyyMM;

  return new Date(year, month - 1, 1).toLocaleDateString("fr-FR", {
    month: "long",
    year: "numeric",
  });
}

export function formatMonthShort(yyyyMM) {
  if (!yyyyMM) return "—";

  const [year, month] = String(yyyyMM).split("-").map(Number);

  if (!year || !month) return yyyyMM;

  return new Date(year, month - 1, 1).toLocaleDateString("fr-FR", {
    month: "short",
  });
}

export function getAdherentName(adherent) {
  const nom = String(adherent?.nom || "").trim().toUpperCase();
  const prenom = String(adherent?.prenom || "").trim();

  return `${nom} ${prenom}`.trim() || "Adhérent";
}

export function buildAttendanceRows(month, adherentsList = [], attendancesList = []) {
  if (!month || !Array.isArray(adherentsList)) return [];

  const days = daysArray(month);

  const monthAttendances = (attendancesList || []).filter((attendance) =>
    String(attendance.date_presence).slice(0, 7).startsWith(month)
  );

  const attendanceMap = {};

  monthAttendances.forEach((attendance) => {
    const adherentId = Number(attendance.adherent_id);
    const day = String(attendance.date_presence).slice(8, 10);

    if (!attendanceMap[adherentId]) {
      attendanceMap[adherentId] = {};
    }

    attendanceMap[adherentId][day] = !!attendance.presence;
  });

  return adherentsList.map((adherent) => {
    let totalPresent = 0;
    let totalAbsent = 0;

    const dates = {};

    days.forEach((day) => {
      const value = attendanceMap[adherent.id]?.[day];

      if (value === true) {
        totalPresent += 1;
      } else if (value === false) {
        totalAbsent += 1;
      }

      dates[day] = value;
    });

    const totalMarked = totalPresent + totalAbsent;
    const rate =
      totalMarked > 0 ? Math.round((totalPresent / totalMarked) * 100) : 0;

    return {
      id: adherent.id,
      nom: adherent.nom || "",
      prenom: adherent.prenom || "",
      adherent,
      dates,
      totalPresent,
      totalAbsent,
      totalMarked,
      rate,
    };
  });
}

export function getCellMeta(value) {
  if (value === true) {
    return {
      label: "Présent",
      short: "P",
      className:
        "bg-emerald-500 text-white ring-emerald-500/30 hover:bg-emerald-600",
    };
  }

  if (value === false) {
    return {
      label: "Absent",
      short: "A",
      className: "bg-rose-500 text-white ring-rose-500/30 hover:bg-rose-600",
    };
  }

  return {
    label: "Non saisi",
    short: "",
    className:
      "bg-slate-100 text-slate-400 ring-slate-200 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-500 dark:ring-slate-700 dark:hover:bg-slate-700",
  };
}